export default function useIsApplePayAvailable(){
    if(typeof ApplePaySession === "undefined")return false

    return ApplePaySession.canMakePayments()
}